import { useParams } from 'react-router'
import toInteger from 'lodash/toInteger'
import toString from 'lodash/toString'
import { ROUTE_ORDERS, buildNavPathTrader } from '@klear/constants'
import { useNavigateWithReturnUrl } from '@klear/ui/wizard/return-url'
import type { WizardStepComponentProps } from '@klear/ui/wizard/flow'
import { OrderSelectOrCreate } from '@/app/order/workflow/OrderSelectOrCreate'
import type { ReceivableStepCtx } from '@/app/receivable/workflow/ReceivableWizardContext'

export default function SelectOrderStep({ ctx }: WizardStepComponentProps<ReceivableStepCtx>) {
  const { traderId: traderIdParam } = useParams<{ traderId?: string }>()
  const traderId = toInteger(traderIdParam)
  const { navigateWithReturnUrl } = useNavigateWithReturnUrl()
  const { form, patchFormAndGoNext } = ctx

  return (
    <OrderSelectOrCreate
      traderId={traderId}
      defaultOrderId={form.orderId}
      onSelected={(orderId) =>
        patchFormAndGoNext((draft) => {
          draft.orderId = orderId
        })
      }
      onCreateNew={() => navigateWithReturnUrl(buildNavPathTrader(toString(traderId), ROUTE_ORDERS, 'new'))}
    />
  )
}
